<div class="content" data-cy="users-list">
  <h2 id="people-table-identifier" class="title">Users</h2>
  <div class="interactables-row">
    <span class="search-and-filter">
      <ciao-form-field
        label="Search"
        placeholder="Type to search..."
        [formControlInput]="searchTextControl"
        data-cy="user-search"
      ></ciao-form-field>
    </span>
    <button
      class="btn-action-solid filter-btn"
      (click)="filterModal.openModal()"
    >
      <fa-icon [icon]="filter"></fa-icon> Filter
    </button>
  </div>
  <ciao-page-selector
    [displayRowCount]="true"
    [tableName]="'Users'"
    [paginationResult]="paginationResult$ | async"
  ></ciao-page-selector>
  <div class="scroll-x-on-overflow">
    <table
      ciao-table-style-v1
      [attr.aria-describedby]="'people-table-identifier'"
    >
      <thead>
        <tr>
          <th class="expander-column">
            <span class="screenreader">Click To Expand</span>
          </th>
          <th
            ciaoSortableHeader
            [sortingBy$]="sortingBy$"
            [sortId]="'firstName'"
          >
            First Name
          </th>
          <th
            ciaoSortableHeader
            [sortingBy$]="sortingBy$"
            [sortId]="'lastName'"
          >
            Last Name
          </th>
          <th>Roles</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody *ngIf="paginationResult$ | async as paginationResult">
        <ng-template [ngIf]="paginationResult.isLoading">
          <tr class="messageRow">
            <td [attr.colspan]="7">
              <ciao-loading></ciao-loading>
            </td>
          </tr>
        </ng-template>
        <ng-template
          ngFor
          let-person
          [ngForOf]="paginationResult?.rows"
          let-i="index"
          [ngForTrackById]
        >
          <tr (click)="openUserModal(person)">
            <td class="expander">
              <button (click)="toggleExpandedRows(person, 'toggle', $event)">
                <span class="material-icons" aria-hidden="true">
                  {{ isSelected(person) ? "expand_more" : "chevron_right" }}
                </span>
                <span class="screenreader">
                  {{ isSelected(person) ? "Collapse" : "Expand" }}
                </span>
              </button>
            </td>
            <td class="person-name">{{ person.firstName }}</td>
            <td class="person-name">
              {{ person.lastName }}
              <ciao-guest-badge
                [person]="person"
                variant="table"
              ></ciao-guest-badge>
            </td>
            <td class="expander nowrap">
              <button (click)="toggleExpandedRows(person, 'toggle', $event)">
                {{ person.AssignedRoles?.length }} Role(s)
              </button>
            </td>
            <td class="email">
              <span *ngFor="let user of person.users">
                {{ user.email }}
                <ng-container *ngIf="isUnverifiedUsda(user)">
                  <span
                    class="material-icons unverified-usda"
                    matTooltip="usda.gov email address is not verified"
                    matTooltipPosition="above"
                    aria-hidden="true"
                    data-cy="unverified-usda-warning"
                    >warning</span
                  >
                  <!-- The icon is aria-hidden, so the tooltip's own
                       aria-describedby won't reach a screen reader. -->
                  <span class="screenreader"
                    >usda.gov email address is not verified</span
                  >
                </ng-container>
              </span>
            </td>
          </tr>
          <ng-container *ngIf="isSelected(person)">
            <ng-template
              ngFor
              let-role
              [ngForOf]="person.AssignedRoles"
              let-roleIndex="index"
              [ngForTrackById]
            >
              <tr class="role-row">
                <td></td>
                <td class="user-group-label" colspan="2">
                  {{ role.userGroup?.labelPrefix }}{{ role.userGroup?.label }}
                </td>
                <td>{{ role.role?.label }}</td>
              </tr>
            </ng-template>
            <tr class="messageRow" *ngIf="!person.AssignedRoles">
              <td [attr.colspan]="7">
                <ciao-loading></ciao-loading>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </tbody>
    </table>
  </div>
  <ciao-page-selector
    class="pageSelector"
    (paginationDataChange)="pagingInfo$.next($event)"
    [tableName]="'People'"
    [paginationResult]="paginationResult$ | async"
    [filteredMessage]="paginationMessage"
  ></ciao-page-selector>
</div>

<ciao-user-modal #userModal [id]="personId"></ciao-user-modal>

<ciao-filter-modal
  #filterModal
  (applyFilters)="applyFilters$.next()"
  [includeRolesFilters]="true"
  [includeGroupFilters]="true"
></ciao-filter-modal>
